import { COLUMNS } from './constants';

import { CustomMenuIcon, CustomColumnMenu, DATAGRID_COMMON_STYLE } from '@commons/utils/dataGrid';

// See https://mui.com/x/api/data-grid/data-grid-pro/ for reference
const DATAGRID_OTHER_PROPS = {
  autosizeOnMount: true,
  disableColumnResize: false,
  disableColumnSelector: true,
  disableDensitySelector: true,
  disableRowSelectionOnClick: true,
  ignoreDiacritics: true,
  showCellVerticalBorder: false,
  showColumnVerticalBorder: false,
};

const DATAGRID_INITIAL_STATE = {
  pinnedColumns: {
    left: [COLUMNS.CHECKBOX, COLUMNS.NAME, COLUMNS.CATEGORY],
    right: [COLUMNS.TOTAL],
  },
  columns: {
    columnVisibilityModel: {
      sku: false,
    },
  },
  sorting: {
    sortModel: [
      { field: COLUMNS.CATEGORY, sort: 'asc' },
      { field: COLUMNS.NAME, sort: 'asc' },
    ],
  },
  filter: {
    filterModel: {
      items: [
        { columnField: COLUMNS.SKU, operatorValue: 'contains', value: '' },
        { columnField: COLUMNS.NAME, operatorValue: 'contains', value: '' },
      ],
    },
  },
};

export const DATAGRID_SLOTS = {
  columnMenu: (props) => CustomColumnMenu(props, [COLUMNS.NAME, COLUMNS.CATEGORY, COLUMNS.TOTAL]),
  columnMenuIcon: CustomMenuIcon,
};

const DATAGRID_SLOT_PROPS = {
  toolbar: {
    showQuickFilter: true,
    printOptions: { disableToolbarButton: true },
    csvOptions: { disableToolbarButton: true },
  },
};

export const COMMON_DATAGRID_PROPS = {
  initialState: DATAGRID_INITIAL_STATE,
  sx: DATAGRID_COMMON_STYLE,
  slotProps: DATAGRID_SLOT_PROPS,
  ...DATAGRID_OTHER_PROPS,
};
